import React, { useContext, useState, useCallback, useEffect } from "react";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Box,
  CircularProgress,
} from "@material-ui/core";

import { i18n } from "../../translate/i18n";
import { AuthContext } from "../../context/Auth/AuthContext";
import useSocketListener from "../../hooks/useSocketListener";

const BulkTransferProgressModal = ({ open, total, onCompleted, onError }) => {
  const { user, socket } = useContext(AuthContext);
  const [progress, setProgress] = useState({ current: 0, total: total || 0 });

  useEffect(() => {
    if (open) {
      setProgress({ current: 0, total: total || 0 });
    }
  }, [open, total]);

  const handleEvent = useCallback(
    (data) => {
      if (data.action === "progress") {
        setProgress({ current: data.current, total: data.total });
      }
      if (data.action === "completed") {
        onCompleted?.(data);
      }
      if (data.action === "error") {
        onError?.(data);
      }
    },
    [onCompleted, onError]
  );

  useSocketListener(socket, user, "bulkTransferTickets", handleEvent, [handleEvent]);

  const currentTotal = progress.total || total || 0;
  const percentage = currentTotal > 0 ? Math.round((progress.current / currentTotal) * 100) : 0;

  return (
    <Dialog
      open={open}
      maxWidth="sm"
      fullWidth
      disableBackdropClick
      disableEscapeKeyDown
    >
      <DialogTitle>{i18n.t("bulkTransferTicketModal.progressDialogTitle")}</DialogTitle>
      <DialogContent>
        <div style={{ textAlign: "center", padding: "20px 0" }}>
          <Box position="relative" display="inline-flex" marginBottom={2}>
            <CircularProgress
              variant="determinate"
              value={percentage}
              size={80}
              thickness={4}
            />
            <Box
              top={0}
              left={0}
              bottom={0}
              right={0}
              position="absolute"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Typography
                variant="caption"
                component="div"
                color="textSecondary"
                style={{ fontSize: "14px", fontWeight: "bold" }}
              >
                {`${percentage}%`}
              </Typography>
            </Box>
          </Box>

          <Typography variant="body1" style={{ marginTop: 16 }}>
            {i18n.t("bulkTransferTicketModal.progressText", {
              current: progress.current,
              total: currentTotal,
            })}
          </Typography>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default BulkTransferProgressModal;
